import { render, staticRenderFns } from "./tendering.vue?vue&type=template&id=234f09b0"
import script from "./tendering.vue?vue&type=script&lang=js"
export * from "./tendering.vue?vue&type=script&lang=js"
import style0 from "./tendering.vue?vue&type=style&index=0&id=234f09b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports